export default __webpack_public_path__ + "static/assets/2f57a5396aa1bf61c38edd3f90dc0637.png";